import { render, staticRenderFns } from "./urlTo.vue?vue&type=template&id=37a099aa&scoped=true&"
import script from "./urlTo.vue?vue&type=script&lang=js&"
export * from "./urlTo.vue?vue&type=script&lang=js&"
import style0 from "./urlTo.vue?vue&type=style&index=0&id=37a099aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a099aa",
  null
  
)

export default component.exports